__turbopack_context__.v({
  "button": "styles-module-scss-module__b09eIq__button",
});
